/**
 * Filter a FileList and return a tuple containing two FileList objects, the first list contains all File items that
 * pass the callback, the second contains all items that fail.
 * @param {FileList} files
 * @param {(file: File, index: number) => boolean} callback
 * @returns {[FileList, FileList]}
 */
const splitFileList = ( files, callback ) => {
    if ( files instanceof FileList ) {
        const pass = new DataTransfer();
        const fail = new DataTransfer();
        Array.from( files ).forEach( ( file, index ) => {
            if ( callback( file, index ) ) pass.items.add( file );
            else fail.items.add( file );
        } );
        return [ pass.files, fail.files ];
    }
    return [];
};

export default splitFileList;